"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseICalendarItemUserEntity = void 0;
const iuser_entity_1 = require("./iuser-entity");
function parseICalendarItemUserEntity(data) {
    if (data.user !== null && typeof data.user === 'object')
        data.user = (0, iuser_entity_1.parseIUserEntity)(data.user);
    return data;
}
exports.parseICalendarItemUserEntity = parseICalendarItemUserEntity;
